import * as React from 'react';

import { PromoItem } from '../../../components/PromoItem';
import { IPromo } from '../../../types/newbuilding/promos';
import { trackHoverPromoBlock } from '../tracking';

interface IPromoContainerProps {
  newbuildingId: number;
  onClick(promo: IPromo): void;
  promo: IPromo;
}

export function PromoItemContainer({ promo, onClick, newbuildingId }: IPromoContainerProps) {
  const handleClick = React.useCallback(() => {
    onClick(promo);
  }, [promo, onClick]);

  const hoverPromo = React.useCallback(() => {
    trackHoverPromoBlock({
      newbuildingId,
      promoType: promo.promoType,
      promotionId: promo.promoId,
    });
  }, [promo, newbuildingId]);

  return <PromoItem promo={promo} onClick={handleClick} onHover={hoverPromo} />;
}
